import { useForm } from 'react-hook-form';
import s1 from '../../assets/images/background/bienvenido-fastcapital.png'
import imgBackground from '../../assets/images/background/fondo-fast-capital.png'
import WaveButton from '../global/WaveButton';
import CONFIGURACIONES from '../../util/constants';
import { Http } from '../../helpers/Http';
import { useContext, useEffect, useState } from 'react';
import { Functions } from '../../helpers/Functions';

import { AuthContext } from "./AuthProvider";
import { useNavigate } from 'react-router-dom';

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = () => {
    const { register:registerForm1, handleSubmit: handleSubmitForm1, 
        getValues: getValuesForm1, formState: { errors: errorsForm1 } } = useForm({mode: "onChange"});

    const { register,handleSubmit, formState: { errors } } = useForm({mode: "onChange"});
    
    const [isAuthenticated, setIsAuthenticated] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const [isIdentified, setIsIdentified] = useState(CONFIGURACIONES.INIT.STATUS_FALSE);
    const { checkToken, signOut } = useContext(AuthContext);
 
    const redirect = useNavigate();

    const loginForm = (form) => {
        form = {...form, ...getValuesForm1()};
        let data = {
            body: form
        }
        Http().post(CONFIGURACIONES.ENDPOINTS.LOGIN, data).then((rpta) => {
            
            if (rpta.status === CONFIGURACIONES.RESPONSES.ERROR) {
                toast.error('Credenciales No Válidas', { position: CONFIGURACIONES.POSITION.BOTTOM_RIGHT});
                return;
            }

            localStorage.setItem('token', Functions().encrypData(rpta.data.token));
            // localStorage.setItem('expira', Functions().encrypData(rpta.data.expira));

            setIsAuthenticated(CONFIGURACIONES.INIT.STATUS_TRUE);
            redirect(CONFIGURACIONES.INIT_REDIRECT_PAGE);
        });
    };

    const identifyAsociado = (form) => {
        let data = {
            body: form
        }

        Http().post(`${CONFIGURACIONES.ENDPOINTS.IDENTIFY_COMPANY}`, data).then((rpta) => { 
            
            if (rpta.status === CONFIGURACIONES.RESPONSES.ERROR) {
                toast.error('Empresa no Encontrada', {position: CONFIGURACIONES.POSITION.BOTTOM_RIGHT});
                return;
            }
            localStorage.setItem('Public-Key', Functions().encrypData(rpta.data.publicKey));
            setIsIdentified(CONFIGURACIONES.INIT.STATUS_TRUE);
            toast.success('Empresa Identificada con Éxito', {position: CONFIGURACIONES.POSITION.BOTTOM_RIGHT});
        });
    };

    useEffect(() => {
        // console.log('check', checkToken());
        
        if (checkToken() === true) {
            return redirect(CONFIGURACIONES.INIT_REDIRECT_PAGE);
            //console.log('auth', auth);
           // return <Navigate to="/view/especialidades" />
        } else {
            // signOut();
        }
    }, [checkToken])

    return (
        <>
        <div className="container-fluid">
            <div className="row min-vh-100">
                <div className="col-md-6 d-none d-md-flex p-0">
                    <img
                        src={imgBackground}
                        alt="Imagen de fondo"
                        className="img-fluid w-100 h-100 object-fit-cover"
                        style={{ objectFit: 'cover',  objectPosition: 'right center' }}
                    />
                </div>

                <div className="col-md-6 d-flex align-items-center justify-content-center">
                    <form className="w-75 text-center" id="loginform" onSubmit={handleSubmit(loginForm)} method="POST">
                        <img
                            src={s1}
                            alt="Logo"
                            className="mb-2"
                            style={{ width: '120px', height: 'auto' }}
                        />

                        <h3 className="mb-4 text-center">Iniciar Sesión</h3>
                        <div className="form-group text-left">
                            <label>Usuario</label>
                            <input type="text" className="form-control" {...register('usuario', {required: CONFIGURACIONES.INIT.REQUIRED})} />
                        </div>
                        <div className="form-group text-left">
                            <label>Contraseña</label>
                            <input type="password" className="form-control" {...register('clave', {required: CONFIGURACIONES.INIT.REQUIRED})} />
                        </div>
                        <WaveButton className="btn btn-success w-100 mt-3" type="submit" id="btnLogin">Entrar</WaveButton>
                    </form>
                </div>

            </div>
        </div>
            {/*
        <div className="row">
            <div className="col-xl-10 col-lg-9 col-md-8 d-none d-md-block px-0">
                <img src={imgBackground} alt="Img de Fondo" className="w-100"/>
            </div>
            <div className="col-xl-2 col-lg-3 col-md-4 col-xs-12 px-md-0 px-sm-3">
                <div className="auth-wrapper d-flex no-block justify-content-center align-items-center">
                    <div className="auth-box on-sidebar">
                        <div id="loginform" className="p-1">
                            <div className="logo">
                                <span className="db"><img src={s1} width="90" alt="logo" /></span>
                                <h5 className="font-medium m-b-10 m-t-20">¡Bienvenido!</h5>
                            </div>
                             <div className="row">
                                <div className="col-12">
                                    <form className="form-horizontal m-t-20" id="loginform" onSubmit={handleSubmit(loginForm)} method="POST" >
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text" id="basic-addon1"><i className="ti-user"></i></span>
                                            </div>
                                            <input {...register('usuario', {required: CONFIGURACIONES.INIT.REQUIRED})} type="text" className="form-control form-control-lg" id="usuario" name="usuario" placeholder="Usuario" aria-label="Usuario"  required="" aria-describedby="basic-addon1" />
                                            <small className="invalid-feedback"> { errors.usuario && errors.usuario.message }</small>
                                        </div>
                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text" id="basic-addon2"><i className="ti-eye"></i></span>
                                            </div>
                                            <input {...register('clave', {required: CONFIGURACIONES.INIT.REQUIRED})} type="password" className="form-control form-control-lg" name="clave" id="clave" placeholder="Contraseña" aria-label="Contraseña"  required="" aria-describedby="basic-addon1" />
                                            <small className="invalid-feedback"> { errors.clave && errors.clave.message }</small>
                                        </div>

                                        <div className="form-group row">
                                            <div className="col-md-12">
                                                <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input" id="customCheck1" />
                                                    <label className="custom-control-label" htmlFor="customCheck1">Recordarme</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group text-center">
                                            <div className="col-xs-12 p-b-20">
                                                <WaveButton className="btn btn-block btn-lg btn-info" type="submit" id="btnLogin">Iniciar Sesión</WaveButton>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div id="error-message">
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        */}
        </>
    )
}

export default Login;